import { THEME } from "@digitallab/grid-common-frontend-components";
import { CircularProgress } from "@mui/material";
import { OwcHorizontalStepper, OwcHorizontalStep, OwcButton, OwcTooltip } from "@one/react";
import { react18WorkaroundProps } from "../utils/constants/react18WorkaroundProps";

export const Stepper = ({
  onCancel,
  presentStep,
  setStep,
  steps,
  nextStepDisabled,
  finishText = "Save",
  finishDisabled,
  stepperStyle,
  handleFinish,
  isSubmitting
}: {
  onCancel: () => {};
  presentStep: number;
  setStep: (number: number) => void;
  steps: { mainText: string; optionalText: string; tooltipText: string }[];
  nextStepDisabled?: boolean;
  finishText: string;
  finishDisabled: boolean;
  stepperStyle?: React.CSSProperties;
  handleFinish: () => {};
  isSubmitting: boolean;
}) => {
  return (
    <>
      <div
        style={{
          width: "100%",
          backgroundColor: THEME["one-color-background-neutral-1"],
          display: "flex",
          justifyContent: "center",
          marginBottom: THEME["one-spacer-16"]
        }}
      >
        <OwcHorizontalStepper
          {...react18WorkaroundProps}
          activeStep={presentStep}
          style={stepperStyle}
          condensed
          linear
        >
          {steps.map(({ optionalText, mainText, tooltipText }, index) => (
            <OwcHorizontalStep
              {...react18WorkaroundProps}
              id={`stepper${mainText}`}
              key={index}
              number={index}
              completed={index < presentStep}
              optionalText={optionalText}
              style={{ pointerEvents: "inherit" }}
            >
              <div>{mainText}</div>
              {tooltipText && (
                <OwcTooltip
                  {...react18WorkaroundProps}
                  anchor={`stepper${mainText}`}
                  placement="bottom"
                  style={{ maxWidth: "600px" }}
                >
                  {tooltipText.split("\n").map((line, idx) => (
                    <div key={idx}>{line}</div>
                  ))}
                </OwcTooltip>
              )}
            </OwcHorizontalStep>
          ))}
        </OwcHorizontalStepper>
      </div>
      <div
        style={{
          width: "100%",
          zIndex: 3,
          left: 0,
          bottom: THEME["one-spacer-28"],
          position: "fixed",
          display: "flex",
          justifyContent: presentStep === 0 ? "flex-end" : "space-between",
          padding: THEME["one-spacer-16"],
          backgroundColor: THEME["one-color-cobas-accent-gray-100"]
        }}
      >
        <div>
          {presentStep !== 0 && (
            <OwcButton
              {...react18WorkaroundProps}
              onClick={() => setStep(presentStep - 1)}
              variant="secondary"
            >
              Previous
            </OwcButton>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <OwcButton
            {...react18WorkaroundProps}
            onClick={onCancel}
            variant="secondary"
            style={{ marginRight: THEME["one-spacer-32"] }}
          >
            Cancel
          </OwcButton>
          {presentStep < steps.length - 1 ? (
            <OwcButton
              {...react18WorkaroundProps}
              disabled={nextStepDisabled}
              onClick={() => setStep(presentStep + 1)}
            >
              Next
            </OwcButton>
          ) : (
            <OwcButton {...react18WorkaroundProps} onClick={handleFinish} disabled={finishDisabled || isSubmitting}>
              <div style={{ display: "flex" }}>
                {isSubmitting && (
                  <>
                    <CircularProgress size={20} />
                    &nbsp;
                  </>
                )}
                {finishText}
              </div>
            </OwcButton>
          )}
        </div>
      </div>
    </>
  );
};
